import { template as template_137583f5600a443abf62d7b64b773fc2 } from "@ember/template-compiler";
import PowerSelect from 'eflex/components/power-select';
const LEVELS = [
    'Month',
    'Week',
    'Day',
    'Hour'
];
export default template_137583f5600a443abf62d7b64b773fc2(`
<div class="level-selector component-bi-dropdown">
  <PowerSelect
    @options={{LEVELS}}
    @selected={{@selectedLevel}}
    @onChange={{@onSelectedLevel}}
  as |level|>
    {{level}}
  </PowerSelect>
</div>
`, {
    eval () {
        return eval(arguments[0]);
    }
});
